<template>
    <div>
        <h1>Admin Suche</h1>


        <div v-if="!tcustomers.length">keine Treffer</div>


        <div v-for="c in tcustomers" class="search-result">
            <div class="search-result-header">
                <div class="aponame"><b>{{ c.name }}</b></div>
                <div class="kdnr"><b>KdNr:</b> {{ c.id }}<span v-if="c.contact">, {{c.contact }}</span></div>
                <div class="links">
                    <a target="_blank" :href="BuildPCRAdminLink(c)">PCRAdmin Login</a>
                </div>
            </div>

            <table border=1 v-if="cats.includes('Sample')">
                <thead>
                    <th width="150">Barcode</th>
                    <th width="140">Testdatum</th>
                    <th width="80">Target</th>
                    <th width="120">Befundung</th>
                    <th width="120">CT Wert</th>
                    <th width="120">Letzer Cycle</th>
                    <th></th>
                    <th></th>
                </thead>
                <tr v-for="r in sugg">
                    <td>&nbsp;{{ r.wellBarcode }}</td>
                    <td>{{ r.testDate }}</td>
                    <td align="center">{{ r.wellTarget }}</td>
                    <td align="center">{{ r.wellPositive == 1 ? "Positiv" : "Negativ" }}</td>
                    <td align="center">
                        <span v-if="r.wellPositive == 1 && r.wellTarget =='ROX'">{{ r.wellValue }}</span><span v-else>-</span>
                    </td>
                    <td align="center">
                        {{r.wellDataAmpL }}
                    </td>
                    <td>
                        <a v-on:click="ShowCurves(r)">Kurven</a>
                    </td> 
                </tr>
            </table>
            <table border=1 v-if="cats.includes('CYCLER')">
                <thead>
                    <th width="90">Seriennummer</th>
                    <th width="80">Online</th>
                    <th width="120">Status</th>
                    <th>Aktionen</th>
                </thead>
                <tr v-for="r in sugg.filter(e => e.apoCustomerId == c.id)">
                    <td align="center">{{r.cyclerSerial }}</td>
                    <td align="center">{{r.isOnline == 1 ? "Ja" : "Nein" }}</td>
                    <td align="center">
                        <span v-if="r.isOnline == 1">
                        <span v-if="r.cyclerState==0">Bereit</span>
                        <span v-if="r.cyclerState==1">in Ausarbeitung</span>
                        <span v-if="r.cyclerState==99" style="color: red"><b>FW UPDATE</b></span>
                        <span v-if="r.cyclerState==null" style="color: purple">Unbekannt</span>
                        </span><span v-else>-</span>
                    </td>
                    <td>
                        <a v-if="r.isOnline == 1" :href="BuildAnyDeskLink(r.cyclerAnyDeskId)">Fernwartung starten</a>
                    </td>

                    
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
export default({
    props: [ 'suggestions'],
    data() {
        return {
            cache: [],
            customers: [],
            sugg: [],
            cats: [],
        }
    },
    methods: {
        ShowCurves(a) {
            this.$router.push({
                name: 'ShowCurves',
                params: {
                    testid: a.testId,
                }
            })
        },
        BuildAnyDeskLink(a) {
            return "anydesk://"+a;
        },
        BuildPCRAdminLink(a) {
            return "/login/"+a.id+"?email="+a.mail+"&curves=true";
        }
    },
    computed: {
        tcustomers() {
            var customers = [];
            this.sugg = [];
            this.cats = [];

            this.suggestions.forEach((r) => {
                var cust_id = r.apoCustomerId;
                if(!customers.find(e => e.id == cust_id)) customers.push({ id: cust_id, name: r.apoName, contact: r.ApoContactPerson, mail: r.apoEmail });
                this.sugg.push(r);
                if(!this.cats.includes(r.ResultType)) this.cats.push(r.ResultType)
            })
            this.customers = customers;
            return customers;
        }
    },
    mounted() {
    },
})
</script>
